import {
   LoanRequestInitFormResponse,
   LoanRequestInitFormResponseData,
} from '../../infrastructure/interfaces/loanRequest/loan-request-init-form.response';
import { apiAdapter } from '../../config/adapters/api.adapter';
import { API_URLS } from '../../constants/api_links';
import { useQuery } from '@tanstack/react-query';

const GetInitLoanRequestForm = async ({
   userId,
}: {
   userId: number;
}): Promise<LoanRequestInitFormResponseData> => {
   const response = await apiAdapter.get<LoanRequestInitFormResponse>(
      `${API_URLS.GET_LOAD_REQUESTS_INIT_FORM}/${userId}`
   );

   return response.data;
};

export const useGetInitLoanRequestForm = ({ userId }: { userId: number }) => {
   return useQuery({
      queryKey: ['getInitLoanRequestForm'],
      queryFn: () => GetInitLoanRequestForm({ userId }),
      retry: false,
   });
};
